import {createJSONStorage, persist} from "zustand/middleware";
import {type AllDictVO, useQueryAllDict} from "@/service/dict.s";
import {create} from "zustand/react";

enum DictEnum {
    AllDict = "allDict",
}

type DictStore = {
    allDict: AllDictVO;
    actions: {
        setAllDict: (payload: AllDictVO) => void;
        clearDict: () => void;
    };
};

const useDictStore = create<DictStore>()(
    persist(
        (set) => ({
            allDict: {},
            actions: {
                setAllDict: (payload: AllDictVO) => set({allDict: payload}),
                clearDict: () => set({allDict: {}}),
            },
        }),
        {
            name: "dictStore",
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                [DictEnum.AllDict]: state.allDict,
            }),
        },
    ),
);

export const useGetAllDict = () => {
    const {setAllDict} = useDictActions();
    const {mutateAsync: queryAllDictMutate} = useQueryAllDict();

    const allDict = async () => {
        const {data} = await queryAllDictMutate();
        setAllDict(data!);
    };
    return allDict;
};

export const useAllDict = () => useDictStore((state) => state.allDict);

export const useDictActions = () => useDictStore((state) => state.actions);
